<!-- layout -->
<cng-layout-legacy id="body-agent" [headerRef]="header" [menuRef]="menu" [mainRef]="main" [footerRef]="footer"></cng-layout-legacy>

<!-- helpzone -->
<cng-agent-helpzone-upgrade [(showHelpzone)]="showHelpzone"> </cng-agent-helpzone-upgrade>

<!-- Header template -->
<ng-template #header>
  <cng-agent-header></cng-agent-header>
</ng-template>

<!-- Menu template -->
<ng-template #menu>
  <cng-agent-menu></cng-agent-menu>
</ng-template>

<!-- Main template -->
<ng-template #main>
  <!-- Contact notification permission -->
  <cng-agent-desktop-notification-permission-btn></cng-agent-desktop-notification-permission-btn>

  <!-- Agent Sub header -->
  <div class="agent-sub-header">
    <!-- Activity form -->
    <cng-activity></cng-activity>
    <!-- Available form -->
    <cng-agent-desktop-user-available-btn></cng-agent-desktop-user-available-btn>
    <!-- Outgoing form -->
    <cng-agent-desktop-phone-unit-cancel-btn></cng-agent-desktop-phone-unit-cancel-btn>
  </div>

  <!-- tabs -->
  <cng-channel-tabs></cng-channel-tabs>

  <!-- sub view -->
  <router-outlet></router-outlet>
</ng-template>

<!-- Footer template -->
<ng-template #footer>
  <cng-footer-legacy
    [infos]="[
      profile$ | async | mapper: getLogin,
      profile$ | async | mapper: getLoginDate | localizedDate: 'medium',
      position$ | async | mapper: getPositionInfo | translate
    ]"
  ></cng-footer-legacy>
</ng-template>
